import { withStyles } from '@material-ui/core';
import { SSearchInput } from '@setvi/shared/components';
import { TextColor } from '@setvi/shared/enums';
import { distances } from '@setvi/shared/styles';

export const StyledSearch = withStyles({
  root: {
    padding: `${distances.px.small} ${distances.px.base}`,
    backgroundColor: '#F8F9FA',
    marginBottom: distances.px.base,
    width: '100%',
    borderRadius: 99,
    height: 40,

    '& input': {
      '&::placeholder': {
        color: `${TextColor.SlateGrey} !important`,
        opacity: '1 !important'
      }
    },

    '& fieldset': {
      border: '1px solid #EEF0F2 !important'
    }
  }
})(SSearchInput);
